import React, { FunctionComponent } from 'react';

import { includes } from 'lodash';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { useReview } from 'reviews2/feed/review-yeti/Review.store';
import { ContextProps, Label } from 'reviews2/feed/review-yeti/Review.types';

import 'reviews2/feed/review-yeti/history/review-history-link/ReviewHistoryLink.scss';

export const ReviewHistoryLink: FunctionComponent<ContextProps> = ({ context }) => {
    const { t } = useTranslation('reviews2');
    const [{ review }] = useReview();
    const { showHistory } = context.options?.historyOptions!;

    const onClickShowHistoryHandler = (event: any) => {
        event.stopPropagation();
        context.handlers?.reviewHistoryClick?.(true);
    };

    return (
        <>
            {showHistory && includes(review?.r4e_label_ids as number[], Label.Updated) ? (
                <Button variant="link" className="review-history-btn" onClick={onClickShowHistoryHandler}>
                    <i className="icon-history" />
                    <span className="btn-text">{t('VIEW_HISTORY')}</span>
                </Button>
            ) : null}
        </>
    );
};
